<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">服务套餐</span>
      <p v-if="renewalOrderEntrance" class="review-renewal-order" @click="reviewRenewalOrder">查询续费订单</p>
    </h2>
    <div class="list-content">
      <el-card>
        <renewal-warning :isChain="isChain" />
        <searchBar :search-params="searchParams" @change="change" @search="search" @reset="resetSearchData" />
        <servicePackageTable
          :page-no="searchParams.pageNo"
          :page-size="searchParams.pageSize"
          :data="data"
          :total="total"
          @handle-pageNo="handlePageNo"
          @handle-pageSize="handlePageSize"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
import searchBar from './components/searchBar.vue';
import servicePackageTable from './components/servicePackageTable.vue';
import renewalWarning from '@/components/renewalWarning/renewalWarning.vue';
import Fetch from '@/api';
import { mapActions, mapState } from 'vuex';
export default {
  components: {
    searchBar,
    servicePackageTable,
    renewalWarning
  },
  data() {
    return {
      searchParams: {
        pageNo: 1,
        pageSize: 10,
        storeName: '',
        serverType: null,
        startTime: '',
        endTime: ''
      },
      data: [],
      total: 0
    };
  },
  computed: {
    ...mapState('global', ['isChain']),
    ...mapState('renewal', ['renewalOrderEntrance'])
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('renewal', ['hasUnpaidOrder', 'hasRenewalOrderEntrance']),
    change(key, val) {
      this.searchParams[key] = val;
    },
    init() {
      this.getRenewalStoreList(this.searchParams);
      this.hasRenewalOrderEntrance();
      this.hasUnpaidOrder('chain');
    },
    search() {
      this.getRenewalStoreList({ ...this.searchParams, pageNo: 1, pageSize: 10 });
    },
    resetSearchData() {
      this.searchParams = { ...this.searchParams, ...{ storeName: '', serverType: null, startTime: '', endTime: '' } };
    },
    async getRenewalStoreList(params) {
      if (!params.serverType) params.serverType = null;
      const res = await Fetch.getRenewalStoreList({ ...params, isRenewal: false });
      this.data = res.data;
      this.total = res.totalCount;
    },
    handlePageNo(pageNo) {
      this.searchParams.pageNo = pageNo;
      return this.getRenewalStoreList({ ...this.searchParams });
    },
    handlePageSize(pageSize) {
      this.searchParams.pageSize = pageSize;
      return this.getRenewalStoreList({ ...this.searchParams });
    },
    reviewRenewalOrder() {
      this.$router.push('chain_renewalOrderList');
    }
  }
};
</script>

<style lang="scss" scoped>
.title-area {
  display: flex;
  justify-content: space-between;
  .review-renewal-order {
    width: 104px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #f2f2f2;
  }
}
</style>
